import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface RawFilesViewerEncounter {
  id: string;
  patient_id: string;
  admit_datetime: string | null;
  discharge_datetime: string | null;
  specialty: string;
}

async function fetchEncounterById(encounterId: string): Promise<RawFilesViewerEncounter | null> {
  const { data, error } = await supabase
    .from("patient_encounters")
    .select("id, patient_id, admit_datetime, discharge_datetime, specialty")
    .eq("id", encounterId)
    .maybeSingle();

  if (error) throw error;
  return data;
}

export function useEncounterById(encounterId: string | null) {
  return useQuery({
    queryKey: ["raw-files-viewer-encounter-by-id", encounterId],
    queryFn: () => fetchEncounterById(encounterId!),
    enabled: !!encounterId,
  });
}
